import CenteredComponent from './CenteredComponent.container';

export default CenteredComponent;
